import './SelectElement.scss';
import { MenuItem, Select, SelectChangeEvent, SelectProps, SxProps, Theme, useTheme } from '@mui/material';

export type ItemOption = {
    value: string,
    label: string,
}

type CustomSelectProps = SelectProps & {
    value: any
    onChange: (event: SelectChangeEvent<any>) => void
    listItems: ItemOption[],
    placeholder?: string
}
const SelectElement = (props: CustomSelectProps) => {
    const theme = useTheme()
    const { value, onChange, listItems, className, placeholder, ...restProps } = props
    const combineClassName = `${className ?? ''} select-element `
    const combineStyle: SxProps<Theme> = { '& legend': { display: 'none' }, '& fieldset': { top: 0 }, height: '36px', backgroundColor: theme.palette.background.input, ...props?.sx }
    const labelOfValue = listItems.find((item: Partial<ItemOption>) => value === item.value)?.label ?? ''
    return (
        <Select {...restProps} sx={combineStyle} className={combineClassName}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={value}
            size='small'
            label="currentAccount"
            onChange={onChange}
            displayEmpty={true}
            renderValue={value => value?.length ? labelOfValue : placeholder ? placeholder : ''}
        >
            {
                listItems.map((item: ItemOption, index: number) => {
                    return <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                })
            }
        </Select>
    )
}

export default SelectElement
